import React from "react";
import { PartMarkingContainer, PartMarkingItem } from "./DisabledForm.style";

interface DisabledPartMarkingType {
  items: string[];
}

export const DisabledPartMarking = ({ items }: DisabledPartMarkingType) => {
  return (
    <PartMarkingContainer>
      {items.map(item => {
        return (
          <PartMarkingItem key={item} kind="body-sm">
            {item}
          </PartMarkingItem>
        );
      })}
    </PartMarkingContainer>
  );
};
